// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-page {
    max-width: 1200px;
    margin: 0 auto;
}

.page-title {
    font-size: 1.75rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 0.25rem 0;
    letter-spacing: -0.5px;
}

.page-subtitle {
    color: #64748b;
    font-size: 0.95rem;
    margin-bottom: 2rem;
}

/* Filters */
.filters-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.filters-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    font-weight: 600;
    color: #334155;
}

.clear-filters {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    background: none;
    border: none;
    color: #64748b;
    font-size: 0.9rem;
    cursor: pointer;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
}

.clear-filters:hover {
    background: #f1f5f9;
    color: #0f172a;
}

.filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
}

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.filter-group label {
    font-size: 0.9rem;
    font-weight: 500;
    color: #334155;
}

.filter-group select,
.filter-group input {
    padding: 0.6rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
    background: white;
}

.filter-group select:focus,
.filter-group input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.filter-group select:disabled {
    background: #f8fafc;
    cursor: not-allowed;
}

.member-search-wrapper {
    position: relative;
}

.member-search-wrapper .search-icon {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
}

.member-search-wrapper input {
    width: 100%;
    padding: 0.6rem 0.6rem 0.6rem 2rem;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 0.9rem;
}

/* Error */
.error-message {
    background: #fee2e2;
    color: #b91c1c;
    padding: 1rem;
    border-radius: 6px;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.error-message button {
    background: #b91c1c;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
}

.error-message button:hover {
    background: #991b1b;
}

/* Table */
.transactions-table-container {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    gap: 1rem;
    color: #64748b;
}

.loading-container .spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.no-data {
    text-align: center;
    padding: 3rem;
    color: #94a3b8;
    font-style: italic;
}

.transactions-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
}

.transactions-table thead {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.transactions-table th {
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    color: #475569;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.transactions-table td {
    padding: 1rem;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
}

.transactions-table tbody tr:hover {
    background: #fafcff;
}

.date-cell {
    white-space: nowrap;
    font-size: 0.85rem;
}

.month-cell {
    text-align: center;
}

.type-badge {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
}

.type-badge.contribution {
    background: #e6f7e6;
    color: #0b5e0b;
}

.type-badge.payout {
    background: #fff4e5;
    color: #b45309;
}

.amount-cell {
    font-weight: 600;
    white-space: nowrap;
}

.mode-cell {
    text-transform: uppercase;
    font-size: 0.8rem;
}

.remarks-cell {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #64748b;
}

/* Pagination */
.pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
    border-top: 1px solid #e2e8f0;
}

.pagination-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    color: #475569;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s;
}

.pagination-btn:hover:not(:disabled) {
    background: #f8fafc;
    border-color: #94a3b8;
}

.pagination-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination-info {
    color: #64748b;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .filters-grid {
        grid-template-columns: 1fr;
    }

    .transactions-table th,
    .transactions-table td {
        font-size: 0.8rem;
        padding: 0.5rem;
    }

    .pagination {
        flex-direction: column;
        gap: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/employee/TransactionHistory.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,YAAY;AACZ;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":[".history-page {\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.page-title {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0 0 0.25rem 0;\n    letter-spacing: -0.5px;\n}\n\n.page-subtitle {\n    color: #64748b;\n    font-size: 0.95rem;\n    margin-bottom: 2rem;\n}\n\n/* Filters */\n.filters-card {\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n\n.filters-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    font-weight: 600;\n    color: #334155;\n}\n\n.clear-filters {\n    margin-left: auto;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    background: none;\n    border: none;\n    color: #64748b;\n    font-size: 0.9rem;\n    cursor: pointer;\n    padding: 0.25rem 0.5rem;\n    border-radius: 4px;\n}\n\n.clear-filters:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n}\n\n.filters-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1rem;\n}\n\n.filter-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.filter-group label {\n    font-size: 0.9rem;\n    font-weight: 500;\n    color: #334155;\n}\n\n.filter-group select,\n.filter-group input {\n    padding: 0.6rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 0.9rem;\n    background: white;\n}\n\n.filter-group select:focus,\n.filter-group input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.filter-group select:disabled {\n    background: #f8fafc;\n    cursor: not-allowed;\n}\n\n.member-search-wrapper {\n    position: relative;\n}\n\n.member-search-wrapper .search-icon {\n    position: absolute;\n    left: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n}\n\n.member-search-wrapper input {\n    width: 100%;\n    padding: 0.6rem 0.6rem 0.6rem 2rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 0.9rem;\n}\n\n/* Error */\n.error-message {\n    background: #fee2e2;\n    color: #b91c1c;\n    padding: 1rem;\n    border-radius: 6px;\n    margin-bottom: 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.error-message button {\n    background: #b91c1c;\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.error-message button:hover {\n    background: #991b1b;\n}\n\n/* Table */\n.transactions-table-container {\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.loading-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 3rem;\n    gap: 1rem;\n    color: #64748b;\n}\n\n.loading-container .spinner {\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.no-data {\n    text-align: center;\n    padding: 3rem;\n    color: #94a3b8;\n    font-style: italic;\n}\n\n.transactions-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.9rem;\n}\n\n.transactions-table thead {\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.transactions-table th {\n    padding: 1rem;\n    text-align: left;\n    font-weight: 600;\n    color: #475569;\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.transactions-table td {\n    padding: 1rem;\n    border-bottom: 1px solid #f1f5f9;\n    color: #334155;\n}\n\n.transactions-table tbody tr:hover {\n    background: #fafcff;\n}\n\n.date-cell {\n    white-space: nowrap;\n    font-size: 0.85rem;\n}\n\n.month-cell {\n    text-align: center;\n}\n\n.type-badge {\n    display: inline-block;\n    padding: 0.25rem 0.5rem;\n    border-radius: 12px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.type-badge.contribution {\n    background: #e6f7e6;\n    color: #0b5e0b;\n}\n\n.type-badge.payout {\n    background: #fff4e5;\n    color: #b45309;\n}\n\n.amount-cell {\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.mode-cell {\n    text-transform: uppercase;\n    font-size: 0.8rem;\n}\n\n.remarks-cell {\n    max-width: 200px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: #64748b;\n}\n\n/* Pagination */\n.pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 1.5rem;\n    border-top: 1px solid #e2e8f0;\n}\n\n.pagination-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    color: #475569;\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.pagination-btn:hover:not(:disabled) {\n    background: #f8fafc;\n    border-color: #94a3b8;\n}\n\n.pagination-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pagination-info {\n    color: #64748b;\n    font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n    .filters-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .transactions-table th,\n    .transactions-table td {\n        font-size: 0.8rem;\n        padding: 0.5rem;\n    }\n\n    .pagination {\n        flex-direction: column;\n        gap: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
